import { render, staticRenderFns } from "./orderAfterSales.vue?vue&type=template&id=bb31f888&scoped=true"
import script from "./orderAfterSales.vue?vue&type=script&lang=js"
export * from "./orderAfterSales.vue?vue&type=script&lang=js"
import style0 from "./orderAfterSales.vue?vue&type=style&index=0&id=bb31f888&prod&scoped=true&lang=css"
import style1 from "./orderAfterSales.vue?vue&type=style&index=1&id=bb31f888&prod&lang=css"
import style2 from "./orderAfterSales.vue?vue&type=style&index=2&id=bb31f888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb31f888",
  null
  
)

export default component.exports